require('./accountLastMovementsMoreInfoRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ actions
const { getMovementDetails, getReceiptPreview, getReceiptDownloading } = require('actions/accountTransactionsDetails');
// @commons
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const { ReceiptPreview } = require('components/commons/receiptPreview/receiptPreview');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKMessage } = require('commonsComponents/OKMessage');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { saveDateFilter } = require('utilities/currentAccountsHelper.js');
const { recordLink } = require('utilities/tagging');
const { toCamelCase } = require('utilities/stringHelper');
// @ constants
const {
    ACCOUNT_MOVEMENT_SEPA_OR_INTERNAL_TRANSFER_CODE,
    ACCOUNT_MOVEMENT_INTERNATIONAL_TRANSFER_CODE,
    ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_ACTION,
    ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_LABEL,
    ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_CATEGORY,
    AMAZON_GIFT_CARD,
    ROUTE_TYPE_FROM_MOVEMENTS
} = require('constants/index');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const { ACCOUNT_DEBITS, LAVANDA } = require('constants/flagBasedFeatures');
const { DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT, DEFERRAL_PAYMENT_CLICK_BUTTON_ACTION_EVENT } = require('constants/tagging');
class AccountLastMovementsMoreInfoRow extends React.Component {

    componentDidMount() {
        const { immTransaction } = this.props;
        const accountId = immTransaction.get('accountId');
        const transactionId = immTransaction.get('id');
        const isReceipt = immTransaction.get('isReceipt');
        const extra = immTransaction.get('extra');
        if(!extra) {
            this.requestDetails(accountId, transactionId, isReceipt)
        } else {
            const movementNumber = extra.get('movementNumber')
            if(movementNumber !== 0) this.requestDetails(accountId, transactionId, isReceipt)
        }
    }

    requestDetails(accountId, transactionId, isReceipt) {
        this.props.getMovementDetails(accountId, transactionId);
        isReceipt && this.props.getReceiptPreview(accountId, transactionId);
    }

    getFilterDate() {
        const { immFilter } = this.props;
        saveDateFilter(immFilter);
    }

    buildReceiptButton() {
        const { immTransaction } = this.props;
        const accountId = immTransaction.get('accountId');

        return (
            <FeatureTogglingRender notAllowedProductKey={ACCOUNT_DEBITS} >
                <div className="account-last-movements-more-info-row__debit-button">
                    <OKLink
                        modifier="complementary"
                        onClick={this.getFilterDate()}
                        size="small"
                        to={`/myprofile/accounts/${accountId}/debits`}
                    >
                        <FormattedText value="accountMovements-debits" />
                    </OKLink>
                </div>
            </FeatureTogglingRender>
        );
    }

    handleReferPaymentOnClick = (immTransaction) => {
        const { flagBasedFeatures, history } = this.props;
        const accountId = immTransaction.get('accountId');
        const id = immTransaction.get('id');

        flagBasedFeatures.get(LAVANDA) && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT, DEFERRAL_PAYMENT_CLICK_BUTTON_ACTION_EVENT)
        history.push(`/myprofile/accounts/${accountId}/defer-payment/${id}`);
    }

    renderReferPaymentButton(immTransaction) {

        return immTransaction.get('finance') == 'S' && (
            <OKButton
                modifier="secondary"
                onClick={() => this.handleReferPaymentOnClick(immTransaction)}
                size="small"
            >
                <FormattedText value="accountMovements-deferPayment" />
            </OKButton>
        )
    }

    renderReusePaymentButton() {
        const { immTransaction } = this.props;
        const productCode = immTransaction.get('product');
        const accountId = immTransaction.get('accountId');
        const transferId = immTransaction.get('id');
        const description = toCamelCase(immTransaction.get('description').trim());
        const isAmazonPurchase = !!description && description.includes(AMAZON_GIFT_CARD);
        const reusePath = `/myprofile/transfers/transfer/emited-reuse/${accountId}/${transferId}/${ROUTE_TYPE_FROM_MOVEMENTS}`;
        if (!isAmazonPurchase && [ACCOUNT_MOVEMENT_SEPA_OR_INTERNAL_TRANSFER_CODE, ACCOUNT_MOVEMENT_INTERNATIONAL_TRANSFER_CODE].includes(productCode)) {
            return (
                <OKButton
                    modifier="secondary"
                    onClick={() => recordLink(ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_CATEGORY, ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_ACTION, ACCOUNT_MOVEMENTS_TRANSFER_REUSE_EVENT_LABEL)}
                    size="small"
                    to={reusePath}
                >
                    <i className="icon-devolver account-last-movements-more-info-row__reuse-icon"/>
                    <FormattedText value="transfersEmited-reUse" />
                </OKButton>
            );
        }
    }

    render() {
        const { id, immTransaction, flagBasedFeatures, originCountry } = this.props;
        const details = immTransaction.get('details');
        const fields = details.get('fields');
        const description = immTransaction.get('description');
        const isReceipt = immTransaction.get('isReceipt');
        const accountId = immTransaction.get('accountId');
        const transactionId = immTransaction.get('id');
        const showPendingValoration = flagBasedFeatures.get('web-movement-fecha-valor-enabled') && immTransaction.get('showPendingValoration');
        let warningMessageContent;
        let transactionDetails;
        let transactionContent;

        if (showPendingValoration) {
            const transferPendingWarningMessage = formatText('accounts-accounts_transferPendingWarningMessage');
            warningMessageContent = (
                <div className="account-last-movements-more-info-row__disclamier">
                    <OKMessage type="informative">
                        {transferPendingWarningMessage}
                    </OKMessage>
                </div>
            )
        }
        if (details.get('loading')) {
            transactionContent = <LoadingSection />;
        } else if (immTransaction.get('extra').get('movementNumber') === 0) {
            const noMovementsText = formatText(
                'accountsTransactionsDetails-selectedMovementHasNoDetails'
            );
            transactionContent = <EmptyState primaryText={noMovementsText} iconType="noitems-banking"/>;
        } else {
            const valueDate = DateHelper.buildFormattedDate(immTransaction.get('valueDate'), DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT);
            if (fields.size > 0) {
                transactionDetails = fields.map(field => {
                    const key = field.get('key');
                    const value = field.get('value');
                    return (
                        <OKTableRowDetailsItem
                            key={'details-' + key}
                            title={key}
                            value={value}
                        />
                    );
                });
            }
            const reusePaymentButton = flagBasedFeatures.get('web-reuse-transfer-enabled') && this.renderReusePaymentButton();

            transactionContent = (
                <OKTableRowDetails title="myMoneyTransactions-detailInformation">
                    <OKTableRowDetailsItem
                        title="accountsTransactionsDetails-movementType"
                        value={description}
                    />
                    <OKTableRowDetailsItem
                        title="accountsTransactionsDetails-valueDate"
                        value={valueDate}
                    />
                    {transactionDetails}
                    <div className="account-last-movements-more-info-row__buttons-container">
                        <span className="account-last-movements-more-info-row__refer-button">
                            {flagBasedFeatures.get("account-revolving", false) && this.renderReferPaymentButton(immTransaction)}
                        </span>
                        <span className="account-last-movements-more-info-row__reuse-button">
                            {reusePaymentButton}
                        </span>
                    </div>
                </OKTableRowDetails>
            );
        }


        return (
            <tr className="account-last-movements-more-info-row" id={id}>
                <td
                    className="account-last-movements-more-info-row__cell container-fluid"
                    colSpan={__CONTACT_CENTER__ ? "12" : "7"}
                >
                    <article className="account-last-movements-more-info-row__content row">
                        <div className="row row-eq-height">
                            <div className="col-sm-6">
                                {transactionContent}
                                {isReceipt && this.buildReceiptButton()}
                            </div>
                            <div className="col-sm-6">
                                {
                                    isReceipt &&
                                    <ReceiptPreview
                                        error={immTransaction.getIn(['preview', 'error'], null)}
                                        loading={immTransaction.getIn(['preview', 'loading'])}
                                        downloading={immTransaction.getIn(['preview', 'downloading'])}
                                        onClickDownloadButton={() => this.props.getReceiptDownloading(accountId, transactionId)}
                                        src={immTransaction.getIn(['preview', 'preview'])}
                                    />
                                }
                            </div>
                        </div>
                        {warningMessageContent}
                    </article>
                </td>
            </tr>
        )
    }
}

AccountLastMovementsMoreInfoRow.propTypes = {
    history: PropTypes.object.isRequired,
    immFilter: PropTypes.object,
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    getMovementDetails: PropTypes.func,
    getReceiptPreview: PropTypes.func,
    getReceiptDownloading: PropTypes.func,
    flagBasedFeatures: PropTypes.object,
    originCountry: PropTypes.string
}

module.exports = connect((state) => ({
        flagBasedFeatures: state.flagBasedFeatures,
        originCountry: state.profile.get('originCountry')
    }), {
        getMovementDetails,
        getReceiptPreview,
        getReceiptDownloading
})(withRouter(AccountLastMovementsMoreInfoRow));
